// extracted by mini-css-extract-plugin
export default {"section3":"section3_section3__ETcIu","image2":"section3_image2__Shr-K"};